<template>
  <div class="page flex-col">
    <Banner />
    <div class="group_1 flex-col">
      <div class="title">
        <img src="./assets/img/wdzp-title.png" alt="">
      </div>
      <div class="card">
        <div class="item" v-for="item in pictureList" :key="item.id">
          <div class="section_1 flex-row justify-between">
            <img class="label_1" referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/pshiw0ptx947fxnxi7lgqyqqhbt9mp2toi7f7cdaf1-57aa-42d1-86e8-88cedb7daa34" />
            <span class="text_1">上传于&nbsp;{{ item.create_date }}</span>
          </div>
          <div v-for="(pic, i) in item.list" :key="i">
            <div class="text-wrapper_1 flex-row">
              <span class="text_2">{{ item.cate_title === '个人' ? pic.name : pic.team_name }}</span>
            </div>
            <div class="text-wrapper_2">
              <span class="text_3">{{ pic.address }}</span>
            </div>
            <div class="section_2 flex-row">
              <div class="image-wrapper_1 flex-row">
                <div class="image_1" @click="openDetails(pic, i)">
                  <div class="status">{{ pic.status_text }}</div>
                  <el-image :src="pic.coverimg" style="width:100%;height:100%" fit="cover">
                    <div slot="placeholder" class="image-slot">
                      加载中
                      <span class="dot">...</span>
                    </div>
                  </el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-wrapper_11 flex-col" @click="toHome">
      <span class="text_7">返回首页</span>
    </div>
    <Footer />
    <Picture :details="details" :show="detailsVisible" @close="detailsClose" />
  </div>
</template>
<script>
import Banner from "@/components/banner/index";
import Footer from "@/components/footer/index";
import Picture from "@/components/picture/index";
import { memberList } from "@/api/index";
export default {
  components: { Banner, Footer, Picture },
  data() {
    return {
      detailsVisible: false,
      pictureList: [],
      total: 0,
      details: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      memberList({ type: 'pc' }).then((res) => {
        this.pictureList = res.data;
      });
    },
    toDetails(id, type) {
      this.$router.push({ path: "/details", query: { id, type } });
    },
    detailsClose() {
      this.details = {};
      this.detailsVisible = false;
    },
    openDetails(item, index) {
      this.details = item;
      this.detailsVisible = true;
    },
    toHome() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
<style scoped lang="scss" src="./assets/index.rem.scss" />
